var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../themes/alert.js";
import { borderRadiusLarge } from "../../themes/borders.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyBook } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
import { mediaPrefersReducedMotion } from "./media-queries.js";
var baseInputStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  appearance: none;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  min-height: 50px;\n  transition:\n    border-color 0.2s ease,\n    color 0.2s ease;\n  width: 100%;\n  ", "\n\n  &:focus {\n    outline: 0;\n  }\n\n  &[aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n"])), fontFamilyBook, mediaPrefersReducedMotion);
var afterBeforeStyle = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex-shrink: 0;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  min-height: 50px;\n  padding: 12px 15px;\n  transition:\n    border-color 0.2s ease,\n    color 0.2s ease,\n    outline 0.1s ease;\n  ", "\n"])), fontFamilyBook, mediaPrefersReducedMotion);
var borderRightRadius = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: ", "px;\n  border-left-width: 0;\n  border-right-width: 1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: ", "px;\n"])), borderRadiusLarge, borderRadiusLarge);
var borderLeftRadius = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: 0;\n  border-left-width: 1px;\n  border-right-width: 0;\n  border-top-left-radius: ", "px;\n  border-top-right-radius: 0;\n"])), borderRadiusLarge, borderRadiusLarge);
var afterStyle = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n\n  &[dir='rtl'] {\n    ", "\n  }\n"])), borderRightRadius, borderLeftRadius);
var beforeStyle = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n\n  &[dir='rtl'] {\n    ", "\n  }\n"])), borderLeftRadius, borderRightRadius);
/**
 * Get Styled Component shared after, before, leftIcon, and rightIcon styles
 * @param options GetInputAddonThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputAddonTheme = function getInputAddonTheme(options) {
  var disabled = options.disabled,
    error = options.error,
    look = options.look;
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    cursor: ", ";\n  "])), function (_ref) {
    var theme = _ref.theme;
    return disabled ? theme.input[look].backgroundColorDisabled : theme.input[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return disabled ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColor;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return disabled ? theme.input[look].textColorDisabled : error ? theme.input[look].textColorError : theme.input[look].textColor;
  }, disabled ? 'not-allowed' : 'default');
};
/**
 * Get Styled Component shared after, before, leftIcon, and rightIcon styles
 * @param options GetInputAddonThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputAddonButtonTheme = function getInputAddonButtonTheme(options) {
  var disabled = options.disabled,
    error = options.error,
    look = options.look;
  return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus-visible {\n      border-color: ", ";\n      outline-color: ", ";\n    }\n\n    &[aria-disabled='true'] {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return disabled ? theme.input[look].backgroundColorDisabled : theme.input[look].backgroundColor;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return disabled ? theme.input[look].borderColorDisabled : theme.input[look].borderColor;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return disabled ? theme.input[look].textColorDisabled : theme.input[look].textColor;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return disabled ? theme.input[look].borderColorDisabled : theme.input[look].borderColorHover;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return disabled ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorFocus;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.input[look].outlineColorFocus;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.input[look].backgroundColorDisabled;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.input[look].borderColorDisabled;
  }, function (_ref12) {
    var theme = _ref12.theme;
    return theme.input[look].textColorDisabled;
  });
};
/**
 * Get Styled Component input border radius
 * @param options GetInputBorderRadiusOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputBorderRadius = function getInputBorderRadius(options) {
  var after = options.after,
    before = options.before;
  if (after && !before) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      border-bottom-left-radius: ", "px;\n      border-top-left-radius: ", "px;\n    "])), borderRadiusLarge, borderRadiusLarge);
  }
  if (!after && before) {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      border-bottom-right-radius: ", "px;\n      border-top-right-radius: ", "px;\n    "])), borderRadiusLarge, borderRadiusLarge);
  }
  if (after && before) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      border-radius: 0;\n    "])));
  }
  return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    border-radius: ", "px;\n  "])), borderRadiusLarge);
};
/**
 * Get Styled Component input padding
 * @param options GetInputPaddingOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputPadding = function getInputPadding(options) {
  var after = options.after,
    before = options.before,
    _options$combobox = options.combobox,
    combobox = _options$combobox === void 0 ? false : _options$combobox,
    leftIcon = options.leftIcon,
    rightIcon = options.rightIcon;
  if (after && before) {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      padding: 12px;\n    "])));
  }
  if (leftIcon && !rightIcon) {
    if (combobox) {
      return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        padding: 12px 50px 12px 40px;\n\n        [dir='rtl'] & {\n          padding: 12px 40px 12px 50px;\n        }\n      "])));
    }
    return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      padding: 12px 15px 12px 40px;\n    "])));
  }
  if (!leftIcon && rightIcon) {
    return css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      padding: 12px 40px 12px 15px;\n    "])));
  }
  if (leftIcon && rightIcon) {
    return css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      padding: 12px 40px;\n    "])));
  }
  if (combobox) {
    return css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      padding: 12px 50px 12px 15px;\n\n      [dir='rtl'] & {\n        padding: 12px 15px 12px 50px;\n      }\n    "])));
  }
  return css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    padding: 12px 15px;\n  "])));
};
/**
 * Get Styled Component input focused border-color
 * @param options GetInputFocusedBorderColorOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputFocusedBorderColor = function getInputFocusedBorderColor(options) {
  var disabled = options.disabled,
    error = options.error,
    loading = options.loading,
    look = options.look;
  return css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), function (_ref13) {
    var theme = _ref13.theme;
    return disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorFocus;
  });
};
/**
 * Get Styled Component input focused border-color
 * @param options GetInputHoveredBorderColorOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputHoveredBorderColor = function getInputHoveredBorderColor(options) {
  var after = options.after,
    before = options.before,
    disabled = options.disabled,
    error = options.error,
    loading = options.loading,
    look = options.look;
  return after && before ? css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        border-bottom-color: ", ";\n        border-left-color: ", ";\n        border-right-color: ", ";\n        border-top-color: ", ";\n      "])), function (_ref14) {
    var theme = _ref14.theme;
    return disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return disabled || loading ? 'transparent' : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return disabled || loading ? 'transparent' : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover;
  }, function (_ref17) {
    var theme = _ref17.theme;
    return disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover;
  }) : css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n        border-color: ", ";\n      "])), function (_ref18) {
    var theme = _ref18.theme;
    return disabled || loading ? theme.input[look].borderColorDisabled : error ? theme.input[look].borderColorError : theme.input[look].borderColorHover;
  });
};
/**
 * Get Styled Component input placeholder color
 * @param options GetInputPlaceholderColorOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputPlaceholderColor = function getInputPlaceholderColor(options) {
  var disabled = options.disabled,
    error = options.error,
    loading = options.loading,
    look = options.look;
  return css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), function (_ref19) {
    var theme = _ref19.theme;
    return disabled || loading ? theme.input[look].textColorDisabled : error ? theme.input[look].textColorError : theme.input[look].textColorPlaceholder;
  });
};
var getInputBackgroundColor = function getInputBackgroundColor(options) {
  var codeEditor = options.codeEditor,
    look = options.look;
  if (codeEditor) {
    return css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral([""])));
  }
  return css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), function (_ref20) {
    var theme = _ref20.theme;
    return theme.input[look].backgroundColor;
  });
};
var getInputColor = function getInputColor(options) {
  var codeEditor = options.codeEditor,
    error = options.error,
    look = options.look;
  if (codeEditor) {
    return css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral([""])));
  }
  return css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), function (_ref21) {
    var theme = _ref21.theme;
    return error ? theme.input[look].textColorError : theme.input[look].textColor;
  });
};
/**
 * Get Styled Component input theme
 * @param options GetInputThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInputTheme = function getInputTheme(options) {
  var after = options.after,
    before = options.before,
    codeEditor = options.codeEditor,
    disabled = options.disabled,
    error = options.error,
    look = options.look;
  var borderColor = after && before ? css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n          border-bottom-color: ", ";\n          border-left-color: ", ";\n          border-right-color: ", ";\n          border-top-color: ", ";\n        "])), function (_ref22) {
    var theme = _ref22.theme;
    return error ? theme.input[look].borderColorError : theme.input[look].borderColor;
  }, function (_ref23) {
    var theme = _ref23.theme;
    return error ? theme.input[look].borderColorError : 'transparent';
  }, function (_ref24) {
    var theme = _ref24.theme;
    return error ? theme.input[look].borderColorError : 'transparent';
  }, function (_ref25) {
    var theme = _ref25.theme;
    return error ? theme.input[look].borderColorError : theme.input[look].borderColor;
  }) : css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n          border-color: ", ";\n        "])), function (_ref26) {
    var theme = _ref26.theme;
    return error ? theme.input[look].borderColorError : theme.input[look].borderColor;
  });
  var disabledBorderColor = after && before ? css(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n          border-bottom-color: ", ";\n          border-left-color: transparent;\n          border-right-color: transparent;\n          border-top-color: ", ";\n        "])), function (_ref27) {
    var theme = _ref27.theme;
    return theme.input[look].borderColorDisabled;
  }, function (_ref28) {
    var theme = _ref28.theme;
    return theme.input[look].borderColorDisabled;
  }) : css(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n          border-color: ", ";\n        "])), function (_ref29) {
    var theme = _ref29.theme;
    return theme.input[look].borderColorDisabled;
  });
  return css(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n\n    &::placeholder {\n      ", "\n    }\n\n    &:hover {\n      ", "\n    }\n\n    &:focus {\n      ", "\n    }\n\n    &[aria-disabled='true'] {\n      background-color: ", ";\n      ", "\n      color: ", ";\n    }\n  "])), getInputBackgroundColor({
    codeEditor: codeEditor,
    look: look
  }), borderColor, getInputColor({
    codeEditor: codeEditor,
    error: error,
    look: look
  }), getInputPlaceholderColor({
    disabled: disabled,
    error: error,
    look: look
  }), getInputHoveredBorderColor({
    after: after,
    before: before,
    disabled: disabled,
    error: error,
    look: look
  }), getInputFocusedBorderColor({
    disabled: disabled,
    error: error,
    look: look
  }), function (_ref30) {
    var theme = _ref30.theme;
    return theme.input[look].backgroundColorDisabled;
  }, disabledBorderColor, function (_ref31) {
    var theme = _ref31.theme;
    return theme.input[look].textColorDisabled;
  });
};
export { afterBeforeStyle, afterStyle, baseInputStyle, beforeStyle, borderLeftRadius, borderRightRadius, getInputAddonButtonTheme, getInputAddonTheme, getInputBorderRadius, getInputFocusedBorderColor, getInputHoveredBorderColor, getInputPadding, getInputPlaceholderColor, getInputTheme };